/* Bundle hero fit.

   The reference site uses object-fit:cover on its hero at 50% width, but their photo is
   composed for that crop — ours is a full-bottle studio shot, so cover sliced the base
   off. contain keeps the whole product inside the panel.

   .bright carries the hero as a CSS background-image, not an <img>, which is the same
   trap that hid the copper bottle on the eye-cream page. eye-fixups.js sets that
   background with setProperty(...,'important'), and an inline !important beats a
   stylesheet !important — so this writes inline too, and re-asserts on a timer to land
   after eye-fixups' last pass at 2000ms. */
(function(){
var s=document.createElement('style');
s.textContent='.lp .bright img{object-fit:contain!important;width:62%!important;padding:6% 0!important}'+
'@media(max-width:820px){.lp .bright img{width:72%!important;padding:8% 0!important}}';
document.head.appendChild(s);

function fit(){
  var br=document.querySelector('.lp .bright'); if(!br) return false;
  if(br.style.backgroundSize!=='contain'){
    br.style.setProperty('background-size','contain','important');
    br.style.setProperty('background-repeat','no-repeat','important');
    br.style.setProperty('background-position','center','important');
  }
  return true;
}
document.addEventListener('DOMContentLoaded',function(){
  [100,600,1400,2200,3000].forEach(function(t){ setTimeout(fit,t); });
});
window.addEventListener('load',function(){ [400,1600,3200].forEach(function(t){ setTimeout(fit,t); }); });
})();